import type { LoadingPlace } from './booking';

export const enum GroupageTripStatus {
  ACTIVE = 1,
  FULL = 2,
  IN_PROGRESS = 3,
  COMPLETED = 4,
  CANCELLED = 5,
}

export interface GroupageTrip {
  id: number;
  vehicle_id: number;
  after_booking_id?: number;
  tenant_id: number;
  status: GroupageTripStatus;
  totalWeightT: number;
  totalLengthM: number;
  remainingWeightT: number;
  remainingLengthM: number;
  combinedRouteLegs: unknown[];
  combinedDistanceKms: number | null;
  combinedEstimatedPrice: number | null;
  startTime: string | null;
  endTime: string | null;
  createdAt: string;
  updatedOn: string;
}

export interface GroupageTripNegotiation {
  id: string;
  offer_id: number;
  vehicle_id: number;
  weightT: number;
  lengthM: number;
  loadingPlaces: LoadingPlace[];
  fePrice: unknown;
  offerStatus: number;
  initiallyOfferedPrice?: number;
  lastOfferedPriceClient?: number;
  lastOfferedPriceUs?: number;
  lastEmailOfferedPrice?: number;
  stop_order?: number;
  createdAt: string;
}

export interface GroupageTripWithNegotiations extends GroupageTrip {
  negotiations: GroupageTripNegotiation[];
}
